var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { OnInit } from '@angular/core';
import { ModalService } from '@services';
import { ModalCommonComponent } from '../modal-common.component';
var ModalAlertComponent = (function (_super) {
    __extends(ModalAlertComponent, _super);
    function ModalAlertComponent(modalService) {
        var _this = _super.call(this) || this;
        _this.modalService = modalService;
        _this.type = 1;
        return _this;
    }
    return ModalAlertComponent;
}(ModalCommonComponent));
export { ModalAlertComponent };
